module.exports = __webpack_public_path__ + "static/media/16.93829761.jpg";